"use client";

import { c as _c } from "react/compiler-runtime";
import { CircleCheckIcon, InfoIcon, Loader2Icon, OctagonXIcon, TriangleAlertIcon } from "lucide-react";
import { useTheme } from "next-themes";
import { Toaster as Sonner, type ToasterProps, toast } from "sonner";
import { createPortal } from "react-dom";
import { useEffect, useState } from "react";
const Toaster = t0 => {
  const $ = _c(11);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  const {
    theme: t1
  } = useTheme();
  const theme = t1 === undefined ? "system" : t1;
  const [mounted, setMounted] = useState(false);
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setMounted(true);
    };
    t3 = [];
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  const t4 = theme as ToasterProps["theme"];
  let t5;
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      success: <CircleCheckIcon className="size-4" />,
      info: <InfoIcon className="size-4" />,
      warning: <TriangleAlertIcon className="size-4" />,
      error: <OctagonXIcon className="size-4" />,
      loading: <Loader2Icon className="size-4 animate-spin" />
    };
    t6 = {
      "--normal-bg": "var(--popover)",
      "--normal-text": "var(--popover-foreground)",
      "--normal-border": "var(--border)",
      "--border-radius": "var(--radius)"
    };
    $[4] = t5;
    $[5] = t6;
  } else {
    t5 = $[4];
    t6 = $[5];
  }
  let t7;
  if ($[6] !== props || $[7] !== t4) {
    t7 = <Sonner theme={t4} className="toaster group" icons={t5} style={t6 as React.CSSProperties} {...props} />;
    $[6] = props;
    $[7] = t4;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const toaster = t7;
  if (!mounted) {
    return null;
  }
  let t8;
  if ($[9] !== toaster) {
    t8 = createPortal(toaster, document.body);
    $[9] = toaster;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  return t8;
};
export { Toaster, toast };